export default __webpack_public_path__ + "static/eric-3d0352d42be637c853087a35204677ec.png";